export const CAMPAIGNS_STATUS = {
  ENABLED: 'ACTIVE',
  DISABLED: 'INACTIVE',
  REMOVED: 'REMOVED'
};

export const CAMPAIGN_TYPE = {
  CLUB: 'HOTMART_CLUB',
  SALES: 'HOTMART_CLUB_SALES',
  AFFILIATE: 'HOTMART_CLUB_SALES_AFFILIATE',
  EXTRA_MODULE: 'HOTMART_CLUB_SALES_EXTRA_MODULE'
};

export const STATUS_BADGE_PROPS = {
  [CAMPAIGNS_STATUS.ENABLED]: {
    label: 'campaign.active',
    variation: 'green'
  },
  [CAMPAIGNS_STATUS.DISABLED]: {
    label: 'campaign.inactive',
    variation: 'gray'
  },
  [CAMPAIGNS_STATUS.REMOVED]: {
    label: 'general.content_removed',
    variation: 'gray'
  }
};

export const CAMPAIGN_MODAL_PROPS = {
  [CAMPAIGNS_STATUS.DISABLED]: {
    title: 'campaign.list.activate_modal.single.title',
    description: 'campaign.list.activate_modal.single.description',
    confirmLabel: 'general.enable',
    iconName: 'play-solid',
    buttonClass: 'campaigns_modal__button__enable'
  },
  [CAMPAIGNS_STATUS.ENABLED]: {
    title: 'campaign.list.desactivate_modal.single.title',
    description: 'campaign.list.desactivate_modal.single.description',
    confirmLabel: 'general.disable',
    iconName: 'pause-solid',
    buttonClass: 'campaigns_modal__button__disable'
  }
};
